export default "__VITE_ASSET__617c0e9a__"